import moment from 'moment'

var filters = {
  capitalize: function (string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
  },
  L: function (date) { return moment(date).format('L') },
  LL: function (date) { return moment(date).format('LL') },
  LT: function (date) { return moment(date).format('LT') },
  ddd: function (date) { return moment(date).format('ddd') },
  dddd: function (date) { return moment(date).format('dddd') },
  D: function (date) { return moment(date).format('D') },
  date: function (date) { return moment(date).format('D. MMMM YYYY') },
  dateNoYear: function (date) { return moment(date).format('dddd, LL') },
  dayOfWeek: function (date, num) { return moment(date).isoWeekday(num) },
  timeStamp: function (value) { return moment(value).format('LT') },
  fromNow: function (m) { return m ? moment(m).fromNow() : '' }
}

export default filters



// WEBPACK FOOTER //
// ./src/filters/filters.js